import Swiper, {Pagination, Navigation, Autoplay} from "swiper";
import lozad from "lozad";

Swiper.use([Pagination, Autoplay, Navigation]);

export function initMainSlider(){

    const swiper = new Swiper('#main_slider', {
        loop: true,
        speed: 900,
        preloadImages:false,
        slidesPerView: 1,
        spaceBetween: 20,
        pagination:{
            el: '.slider-pagination',
            type: 'bullets',
            clickable: true,
        },
        navigation: {
            nextEl: '.main-swiper-next',
            prevEl: '.main-swiper-prev',
        },
        autoplay: {
            delay: 7000,
            disableOnInteraction: false,
        },
        on: {
            slideChangeTransitionStart: function() {
                removeAnimatedClass();
            },
            slideChangeTransitionEnd: function() {
                addAnimatedClass();
                const observer = lozad('.lozad', {
                    load: function (image) {
                        if (image.dataset.mobileBackground) {
                            $(image).css('background-image', 'url(' + image.dataset.mobileBackground + ')');
                        } else {
                            $(image).css('background-image', 'url(' + image.dataset.background + ')');
                        }

                        if (image.dataset.src) {
                            image.src = image.dataset.src;
                        }

                        image.classList.add('fade');
                    }
                });
                observer.observe();
            }
        },
        breakpoints: {
            0: {
                loop: false,
                slidesPerView: 1,
                spaceBetween: 10
            },
            500:{
                slidesPerView: 1,
                spaceBetween: 10
            },
            768: {
                slidesPerView: 1,
                spaceBetween: 40
            }
        }
    });

    function removeAnimatedClass() {
        let animatedElements = $('.swiper-slide-active [data-anim]');
        animatedElements.removeClass('animated').each(function() {
            void this.offsetWidth; // Триггер перерисовки
        });
    }

// функция для добавления класса .animated
    function addAnimatedClass() {
        let animatedElements = $('.swiper-slide-active [data-anim]');
        animatedElements.addClass('animated');
    }




    const paginationBullets = $('.swiper-pagination-bullet');

    function updatePaginationStyle() {
        if ($(window).width() <= 768 && paginationBullets.length > 5) {
            paginationBullets.addClass('small-pagination')
        } else {
            paginationBullets.removeClass('small-pagination')
        }
    }

    $(window).resize(updatePaginationStyle);
    updatePaginationStyle();
}